import WhatDesignSystem from './WhatDesignSystem'

export default WhatDesignSystem
